import { create } from 'zustand';

export interface RolloverToastData {
  pickupUid: string;
  toSlotCode: string;
  toSlotLabel: string;
  toSlotWindow: string;
}

interface RolloverToastState {
  data: RolloverToastData | null;
  dismissedUids: string[];
  setData: (data: RolloverToastData | null) => void;
  dismiss: (uid: string) => void;
}

// Feeds the singleton RolloverToast (bottom-corner "pickup moved to a later
// slot" notification). This is a polled SPA — there is no websocket/push
// channel — so the Pickups page derives `data` itself from the current
// pickups-list query (the most-recent row with slot_response_open === true
// whose uid hasn't been session-dismissed) and calls setData(). dismissedUids
// persists per session so a background refetch doesn't resurrect a toast the
// merchant already closed; PickupSlotCell's in-row Accept/Change/Defer
// handlers also call dismiss() so acting on a row hides any toast showing for
// that same pickup.
//
// NOTE: like useSlotSelectionStore/useChangeSlotStore, this store is
// intentionally NOT exported from the stores barrel — import it via the
// direct path '@/stores/useRolloverToastStore'.
const useRolloverToastStore = create<RolloverToastState>((set) => ({
  data: null,
  dismissedUids: [],
  setData: (data: RolloverToastData | null) => set({ data }),
  dismiss: (uid: string) =>
    set((state) => ({
      dismissedUids: state.dismissedUids.includes(uid)
        ? state.dismissedUids
        : [...state.dismissedUids, uid],
      data: state.data?.pickupUid === uid ? null : state.data,
    })),
}));

export default useRolloverToastStore;
